import { getInterface } from '@/utils/js/initVariable'
const prefixUrl = 'api/SystemApi/'
export const selectUserList = (data)=>{
  return getInterface.post(`${prefixUrl}selectUserList`, data)
}
export const getRoleSelection = (data)=>{
  return getInterface.post(`${prefixUrl}getRoleSelection`, data)
}
export const getAccountTypeSelection = (data)=>{
  return getInterface.post(`${prefixUrl}getAccountTypeSelection`, data)
}
export const addUser = (data)=>{
  return getInterface.post(`${prefixUrl}addUser`, data)
}
export const enableUser = (data)=>{
  return getInterface.post(`${prefixUrl}enableUser`, data)
}
export const delUser = (data)=>{
  return getInterface.post(`${prefixUrl}delUser`, data)
}
export const modifyUserInfo = (data)=>{
  return getInterface.post(`${prefixUrl}modifyUserInfo`, data)
}
export const queryOrdinaryUserList = (data)=>{
  return getInterface.post(`${prefixUrl}queryOrdinaryUserList`, data)
}